<template>
  <v-container>
    <v-list>
      <v-subheader class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
      <v-icon color="blue darken-2">mdi-camera</v-icon>
        <span class="ml-2">{{$t('lang.introductionOfExperts')}}</span>
      </v-subheader>
        <v-list-item v-for="(expert, i) in signUpExperts" :key="i">
          <div style="width:100%">
            <v-card class="d-inline-flex my-2" elevation="0" width="100%" target="_blank" :href="expert.ExpertUrl">
              <van-image style="min-height:80px" fit="cover" radius="10px" lazy-load :width="isMobile() ? '40%' : '30%'" :src="expert.ExpertPhoto">
                <!-- <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template> -->
              </van-image>
              <div class="d-flex align-content-space-between flex-wrap" :style="isMobile() ? 'width: 60%' : 'width: 70%'">
                <v-card-text class="pt-0 pb-0 text-sm-subtitle-1" v-text="expert.ExpertName" style="overflow: hidden;-webkit-line-clamp: 4;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;"/>
                <v-btn class="d-none d-sm-none d-md-flex more ml-4" rounded outlined style="text-transform:none;" color="#1976D2">
                  {{$t('lang.more')}}
                  <v-icon right>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-card>
            <v-btn class="d-flex d-sm-flex d-md-none more" block rounded outlined style="text-transform:none;" color="#1976D2" target="_blank" :href="expert.ExpertUrl">
              {{$t('lang.more')}}
              <v-icon right>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-divider style="margin: 10px 0;border: 1px dashed #F2F2F2"></v-divider>
          </div>
        </v-list-item>
    </v-list>
  </v-container>
</template>
<style>
  .more:hover{
      background: #1976D2;
      color: white !important;
    }
</style>
<script>
import utils from '../utils/utils'
export default {
  name: 'Expert',
  props: ['data'],
  computed: {
    signUpExperts () {
      const lst = []
      for (let index = 0; index < this.data.SignUpExperts.length; index++) {
        const element = this.data.SignUpExperts[index]
        if (element.ExpertType === 3 || element.ExpertType - this.$store.getters.getLanguage === 1) {
          lst.push(element)
        }
      }
      return lst
    }
  },
  methods: {
    isMobile () {
      return utils.methods.isMobile()
    }
  }
}
</script>
